import { render, staticRenderFns } from "./LichSuVeDienTuForm.vue?vue&type=template&id=55bb4447"
import script from "./LichSuVeDienTuForm.vue?vue&type=script&lang=js"
export * from "./LichSuVeDienTuForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports